const PORTAL_PUBLIC_PATH = /^\/portal\/[^/]+(\/register)?\/?$/;

export const WHATS_NEW_UNSUBSCRIBE_PATH = "/unsubscribe/whats-new";

const WHATS_NEW_UNSUBSCRIBE_EXACT_PATH_PATTERN = /^\/unsubscribe\/whats-new\/?$/;

export const isWhatsNewUnsubscribePath = (pathname: string) => WHATS_NEW_UNSUBSCRIBE_EXACT_PATH_PATTERN.test(pathname);

const isPortalPublicPath = (pathname: string) => PORTAL_PUBLIC_PATH.test(pathname);

export default isPortalPublicPath;
